import { buildRoomLink } from '@/config/app-config';

/**
 * Планування дзвінка через шаблон події Google Calendar.
 *
 * Формат URL і тексти події збережено такими самими, як у мобільному клієнті
 * (`calendar_service.dart`), щоб запрошення виглядали однаково незалежно від
 * того, звідки їх створили.
 */
export function buildCalendarUrl(roomId: string): string {
  const roomUrl = buildRoomLink(roomId);
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: 'One2One Video Call',
    details: `Video call room: ${roomUrl}`,
  });
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

export type ScheduleOutcome = 'opened' | 'blocked';

/**
 * Відкриває шаблон події. Якщо браузер заблокував нове вікно (а він блокує
 * все, що відкрито не з жесту користувача), повідомляємо про це — щоб можна
 * було віддати посилання іншим шляхом, а не мовчки нічого не зробити.
 */
export function openCalendar(roomId: string): ScheduleOutcome {
  const opened = window.open(buildCalendarUrl(roomId), '_blank', 'noopener,noreferrer');
  return opened === null ? 'blocked' : 'opened';
}
